import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import VideoPop from "./GoVideos/VideoPop";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const OnSaleFlash = () => {
  const [visible, setVisible] = useState(true);
  const [videoModal, setVideoModal] = useState(false);
  const location = useLocation();
  const pathName = location.pathname;

  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation((prev) => (prev + 2) % 360); // Faster
    }, 20);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible((prev) => !prev);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  if (pathName === "/interview") {
    return null; // Don't show the flash on the interview page
  }

  return (
    <>
      <Link to={"/interview?append=true"}>
        <div
          style={{
            width: "auto",
            maxWidth: "390px",
            cursor: "pointer",
            textAlign: "center",
            position: "absolute",
            padding: "10px",
            right: 0,
            top: 0,
            zIndex: 1,
            alignContent: "center",
          }}
        >
          <div className="button-group">
            <div
              className="shining-border"
              style={{
                background: `conic-gradient(
                  from ${rotation}deg at 50% 50%,
                  #ff9ff3 0deg,
rgb(114, 181, 243) 90deg,
                  #54a0ff 180deg,
                  #5f27cd 270deg,
                  #ff9ff3 360deg
                )`,
              }}
            />
            <motion.button className="shining-button">
              Watch Dr. Mercola & Dr. Litchfield's Video
            </motion.button>
          </div>
        </div>
      </Link>
    </>
  );
};

export default OnSaleFlash;
